import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2c8d06c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "50px",
    "height": "50px"
  },
  src: "https://cdn.waityou.online/78705712-558d-f217-2474-968f023ae569.png"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createBlock(_component_el_row, {
    style: {
      "padding": "10px 0",
      "align-items": "center"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4
    }, {
      default: _withCtx(() => [_hoisted_1]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "clockInfo"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.data.userName) + "·已打卡", 1), _createElementVNode("span", null, _toDisplayString($props.data.createdTime), 1)]),
      _: 1
    })]),
    _: 1
  });
}